import { queryOptions } from '@tanstack/react-query';

import { dashboardApi } from '../api/dashboard.api';
import { DashboardClause } from '../types/stats';

import { Filters, getQueriesWithGlobal, Globals } from '@data-access';
import { organisationApi } from '@organisations/data-access';

const DASHBOARD_ORGANISATIONS_FILTERS: Filters = {
  page: 1,
  sorting: [],
  filters: [{ id: 'page_size', value: 1000 }],
};

export const dashboardQueries = (global: Globals) => ({
  all: () => [global, 'dashboard'],
  news: () =>
    queryOptions({
      queryKey: ['news'],
      queryFn: () => dashboardApi.news(),
    }),
  pratiquesSynthesis: (
    organizationIds: number[] = [],
    ownerIds: number[] | null = null,
    clause: DashboardClause = 'gp',
    campaignYear: number | null = null,
  ) =>
    queryOptions({
      queryKey: [
        ...dashboardQueries(global).all(),
        'pratiques-synthesis',
        organizationIds,
        ownerIds,
        clause,
        campaignYear,
      ],
      queryFn: () =>
        dashboardApi.getPratiquesSynthesis(
          organizationIds,
          ownerIds,
          clause,
          campaignYear,
        ),
    }),
  defaultOrganizationsRecap: (
    ownerIds: number[] | null = null,
    clause: DashboardClause = 'gp',
    campaignYear: number | null = null,
  ) =>
    queryOptions({
      queryKey: [
        ...dashboardQueries(global).all(),
        'default-organizations-recap',
        ownerIds,
        clause,
        campaignYear,
      ],
      queryFn: () =>
        dashboardApi.getDefaultOrganizationsRecap(
          ownerIds,
          clause,
          campaignYear,
        ),
    }),
  organisations: () =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'organisations'],
      queryFn: () => organisationApi.getAll(DASHBOARD_ORGANISATIONS_FILTERS),
    }),
});

export const getDashboardQueries = () => getQueriesWithGlobal(dashboardQueries);
